import { useState } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { listContracts } from "@/lib/contracts.functions";
import { formatContractDate } from "@/lib/contracts";

export const Route = createFileRoute("/_authenticated/admin/contracts/")({
  head: () => ({ meta: [{ title: "Employment contracts | Admin" }] }),
  component: ContractsList,
});

const STATUS_LABEL: Record<string, string> = { awaiting_employee: "Waiting for employee", signed: "Signed by both", cancelled: "Cancelled" };

function ContractsList() {
  const [search, setSearch] = useState("");
  const listFn = useServerFn(listContracts);
  const { data = [], isLoading } = useQuery({ queryKey: ["contracts", search], queryFn: () => listFn({ data: { search } }) as Promise<any[]> });
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-2xl font-bold">Employment contracts</h1>
        <Button asChild><Link to="/admin/contracts/new">Create contract</Link></Button>
      </div>
      <Input placeholder="Search by name, job title or reference" value={search} onChange={(e) => setSearch(e.target.value)} className="max-w-sm" />
      {isLoading ? <p className="text-sm text-muted-foreground">Loading…</p> : data.length === 0 ? <p className="text-sm text-muted-foreground">No contracts yet.</p> : (
        <div className="overflow-x-auto rounded-md border">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left"><tr><th className="p-3">Reference</th><th className="p-3">Employee</th><th className="p-3">Job title</th><th className="p-3">Start</th><th className="p-3">Status</th><th className="p-3" /></tr></thead>
            <tbody>{data.map((c) => (
              <tr key={c.id} className="border-t">
                <td className="p-3 font-mono text-xs">{c.contract_number}</td><td className="p-3">{c.employee_name}</td><td className="p-3">{c.job_title}</td>
                <td className="p-3">{formatContractDate(c.start_date)}</td>
                <td className="p-3"><Badge variant={c.status === "signed" ? "default" : "secondary"}>{STATUS_LABEL[c.status] ?? c.status}</Badge></td>
                <td className="p-3 text-right"><Button size="sm" variant="outline" asChild><Link to="/admin/contracts/$id" params={{ id: c.id }}>Open</Link></Button></td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
